// extracted by mini-css-extract-plugin
export var icon = "Info-module--icon--f8a04";
export var root = "Info-module--root--ac86b";
export var titleRow = "Info-module--titleRow--107fe";